import { Deduction, DeductionFilters } from '../../../../app/models/Deduction';
import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import DeductionSwitchChange from '../DeductionSwitchChange';
import { formatNumberWithDots } from '../../../../helpers';
import DeductionFilter from './DeductionFilter';

interface Props {
    deductions: Deduction[];
    totalRows: number;
    loading?: boolean;
    edit?: (id: number) => void;
    active?: (id: number, active: boolean) => void;
    show?: (id: number) => void;
    destroy?: (id: number) => void;
    filter: DeductionFilters;
    setFilter: (filter: DeductionFilters) => void;
    paginationRowsPerPageOptions?: any[];
    callbackSuccess: () => void;
    onSearch: () => void;
}

const DeductionDataTable = ({
    deductions,
    totalRows,
    loading = false,
    edit,
    active,
    show,
    destroy,
    filter,
    setFilter,
    callbackSuccess,
    onSearch
}: Props) => {
    const columns = [
        {
            name: 'Nombre',
            selector: (row: any) => row.name,
            sortable: true,
            sortField: 'name',
            cell: (row: any, index: any, column: any) => <span className="">{row.name}</span>
        },
        {
            name: 'Descripción',
            selector: (row: any) => row.description,
            sortable: true,
            sortField: 'description',
            cell: (row: any, index: any, column: any) => <span className="">{row.description}</span>
        },
        // {
        //     name: 'Valor',
        //     selector: (row: any) => row.amount,
        //     sortable: true,
        //     sortField: 'amount',
        //     cell: (row: any, index: any, column: any) => {
        //         return (
        //             <>
        //                 {row.type_of_deductions === "Fijo" ? (
        //                     <span className="">{formatNumberWithDots(row.amount) + ' CLP'}</span>
        //                 ) : row.type_of_deductions === "Porcentaje" ? (
        //                     <span className="">
        //                         {row.amount}
        //                     </span>
        //                 ) : null}
        //             </>
        //         );
        //     }
        // },
        // {
        //     name: 'Tipo de deducción',
        //     selector: (row: any) => row.type_of_deductions,
        //     sortable: true,
        //     sortField: 'type_of_deductions',
        //     cell: (row: any, index: any, column: any) => (
        //         <span className="">{row.type_of_deductions}</span>
        //     )
        // },
        // {
        //     name: 'Fecha de inicio',
        //     selector: (row: any) => row.start_date,
        //     sortable: true,
        //     sortField: 'start_date',
        //     cell: (row: any, index: any, column: any) => <span className="">{row.start_date}</span>
        // },
        // {
        //     name: 'Fecha de fin',
        //     selector: (row: any) => row.end_date,
        //     sortable: true,
        //     sortField: 'end_date',
        //     cell: (row: any, index: any, column: any) => <span className="">{row.end_date}</span>
        // },
        {
            name: 'Activo',
            selector: (row: any) => row.is_active,
            sortable: true,
            sortField: 'is_active',
            cell: (row: any, index: any, column: any) => (
                <DeductionSwitchChange
                    checkValue={row.is_active ?? true}
                    DeductionId={row.id!}
                    callbackSuccess={callbackSuccess!}
                />
            )
        },
        {
            name: 'Acciones',
            selector: (row: any) => row.id,
            sortable: false,
            cell: (row: any, index: any, column: any) => (
                <div className="">
                    {edit && (
                        <ButtonTableAction
                            callbackFunction={() => edit(row.id ?? -1)}
                            classIcon={'mdi mdi-pencil'}
                            colorIcon={'text-warning'}
                            errorMessage={'No se puede editar este registro.'}
                            title={'Editar'}
                        />
                    )}
                    {destroy && (
                        <ButtonTableAction
                            callbackFunction={() => destroy(row.id ?? -1)}
                            classIcon={'mdi mdi-delete'}
                            colorIcon={'text-danger'}
                            errorMessage={'No se puede eliminar este registro.'}
                            title={'Eliminar'}
                        />
                    )}
                </div>
            )
        }
    ];

    return (
        <div>
            <div className="row mt-3">
                <div className="col">
                    <DeductionFilter filter={filter} setFilter={setFilter} onSearch={onSearch}/>
                </div>
            </div>

            <DefaultDataTable
                columns={columns}
                data={deductions}
                progressPending={loading}
                paginationTotalRows={totalRows}
                filter={filter}
                setFilter={setFilter}
            />
        </div>
    );
};

export default DeductionDataTable;
